export const AUTH_STORAGE_KEY = "auth-data";

export const TENANT_ELA = "ela";
